

export enum ShopItemState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
  CANCELLED = 'CANCELLED',
  FINISHED = 'FINISHED',
};
